// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2E749","text":"SelectPayment_text__2G39j","title":"SelectPayment_title__aD7ge","btn":"SelectPayment_btn__30P-B"};